// Textos de la fase 4 de flotes de taxi/VTC (docs/flotas-drivers): tipus de
// flota, emissora (parades, zones i repartiment), quota al passatger i reptes.
// Es registren a AppComponent i es fusionen amb drivers-fleet/ca.ts.
export const locale = {
  lang: 'ca',
  data: {
    DRIVERS_FLEET: {
      KIND: {
        dispatch_center: 'Emissora de taxi',
        owner_operator: 'Taxista patró',
        vtc_fleet: 'Flota VTC',
      },
      EMPLOYMENT_TYPE: {
        associate: 'Soci',
      },
      DEMAND_CHANNEL: {
        waiis_app: 'App WAIIS',
        emitter_phone: 'Telèfon de l’emissora',
        emitter_web: 'Web de l’emissora',
        stand: 'Parada',
        street_hail: 'Al carrer',
      },
      SERVICE_TYPE: {
        immediate: 'Immediat',
        reservation: 'Reserva',
        airport_premium: 'Premium o aeroport',
      },
      DISPATCH_STRATEGY: {
        proximity: 'El més proper',
        stand_order: 'Ordre de la parada',
        zone: 'Per zona',
      },
      CHALLENGE_STATUS: {
        draft: 'Esborrany',
        scheduled: 'Programat',
        active: 'En marxa',
        finished: 'Acabat',
        cancelled: 'Cancel·lat',
      },
      SIGNUP: {
        KIND_TITLE_dispatch_center: 'Emissora de taxi',
        KIND_TITLE_owner_operator: 'Propietari de llicències de taxi',
        KIND_TITLE_vtc_fleet: 'Oferir viatges amb llicències VTC',
        KIND_HINT_dispatch_center: 'Associació o ràdio taxi: els teus socis tenen llicència i cotxe propis. Parades, zones i repartiment.',
        KIND_HINT_owner_operator: 'Una o més llicències municipals, amb conductors que les treballen per torns.',
        KIND_HINT_vtc_fleet: 'Empresa o operador amb autoritzacions VTC, amb conductors assalariats o autònoms.',
      },
      GEO: {
        TOOLS_ARIA: 'Eines del mapa',
        DRAW: 'Dibuixar',
        PLACE_POINT: 'Col·locar el punt',
        UNDO: 'Desfer',
        CLEAR: 'Esborrar',
        RECENTER: 'Enquadrar',
        ZOOM_IN: 'Apropar',
        ZOOM_OUT: 'Allunyar',
        HINT_START: 'Prem al mapa per afegir punts ({{count}} de 3 com a mínim).',
        HINT_EDIT: 'Arrossega un punt per moure’l; doble clic per treure’l. Prem al mapa per afegir-ne més.',
        HINT_POINT: 'Prem al mapa o arrossega el marcador per col·locar el punt de la parada.',
        HINT_INVALID: 'Els costats de la zona es creuen: mou o treu algun punt.',
        POLYGON_REQUIRED: 'Dibuixa la zona amb almenys 3 punts i sense que els seus costats es creuin.',
      },
      OPS: {
        SAVE: 'Desar',
        SHIFTS: {
          SUB: 'Es repeteixen cada setmana. Prem una casella per canviar qui condueix aquest cotxe aquell dia.',
          CHANGE_HOURS: 'Canviar hores',
          NO_DRIVER: 'Sense conductor',
          FIXED: 'Torn fix',
          REPEAT: 'Repetir',
          DAY_LETTER: { 1: 'Dl', 2: 'Dt', 3: 'Dc', 4: 'Dj', 5: 'Dv', 6: 'Ds', 7: 'Dg' },
          CLASH: '{{name}} ja té torn de {{slot}} en un altre cotxe algun d’aquests dies.',
          PICK_DAY: 'Tria almenys un dia.',
          CONFLICT: 'Hi ha un conductor en dos cotxes alhora. Revisa els torns.',
          SAVED_TITLE: 'Torn desat',
          SAVED_FROM: 'S’aplica des del {{date}}.',
        },
        VEHICLES: {
          KPIS_ARIA: 'Resum dels vehicles',
          KPI_ON_STREET: 'Al carrer ara',
          KPI_ALERTS: 'ITV o assegurança en menys de 45 dies',
          TAB_ON_STREET: 'Al carrer',
          TAB_PARKED: 'Aturats',
          TAB_WITHOUT_DRIVER: 'Sense conductor',
          TAB_WITH_ALERTS: 'Amb avisos',
          SEARCH: 'Cercar matrícula o model',
          COL_VEHICLE: 'Vehicle',
          COL_KM: 'Km',
          PRESENCE_on_street: 'Al carrer',
          PRESENCE_parked: 'Aturat',
          NEXT_UPLOAD: 'Falten documents per pujar',
          NEXT_SUBMIT: 'Llest per enviar a revisió',
          NEXT_FIX: 'Torna a pujar el que s’ha rebutjat',
          NEXT_WAIT: 'Ho revisem en menys de 24 h',
          N_SHIFTS: '{{count}} torns',
          ASSIGN: 'Assignar conductor',
          COMPLETE: 'Completar',
          EMPTY: 'Encara no hi ha vehicles. Matrícula, llicència i 4 documents: els revisem en 24 h.',
          ADD_SUB: 'Ho revisem en menys de 24 h.',
          REJECTED_NOTE: 'Hi ha un document rebutjat. Torna’l a pujar i el cotxe torna a revisió.',
          MUNICIPALITY: 'Municipi de la llicència',
          MORE_DATA: 'Marca, model, any, places i km',
          YEAR: 'Any',
          KM_HINT: 'L’actualitza l’app del conductor; aquí el pots corregir.',
          DATA_INVALID: 'Revisa l’any (des de 1990) i les places (d’1 a 8).',
          NO_DRIVERS: 'Encara no condueix ningú aquest cotxe.',
          EDIT_SHIFTS: 'Editar torns',
          DOCS_COUNT: 'Documents {{done}}/{{total}}',
          DOC_PENDING: 'Pendent',
          DOC_UPLOADED: 'Pujat',
          DOC_IN_REVIEW: 'En revisió',
          DOC_REJECTED: 'Rebutjat: {{reason}}',
          DOC_UNTIL: 'Vàlid fins al {{date}}',
          DOC_VALID: 'Vàlid',
          CHECKS: {
            circulation_permit: 'Les dues cares|Es veuen les 4 cantonades|Matrícula llegible',
            technical_sheet_itv: 'Les dues cares|Data de la propera ITV visible|Sense ratllades ni reflexos',
            insurance_policy: 'Totes les pàgines|Caducitat i matrícula llegibles|Responsabilitat civil inclosa',
            taxi_municipal_license: 'Número i municipi visibles|Vigent|Una per vehicle',
            vtc_transport_card: 'Del mateix vehicle que el permís de circulació|Número d’autorització llegible|Una per vehicle',
          },
          DOCS_AFTER: 'Desa les dades i després puja els 4 documents.',
          SUBMIT_HINT: 'Amb els 4 documents pujats, envia’l a revisió. Mentrestant queda incomplet.',
          SAVE_AND_DOCS: 'Desar i pujar documents',
          SAVE_LATER: 'Desar i continuar més tard',
          SUBMIT: 'Enviar a revisió',
          SUBMIT_DISABLED: 'Puja els 4 documents per enviar-lo.',
          SUBMITTED_TITLE: '{{plate}} enviat a revisió',
          SUBMITTED_TEXT: 'Ho revisem en menys de 24 h. T’avisarem quan pugui treballar.',
          MISSING_DOCS: 'Falten documents per pujar.',
        },
        OVERVIEW: {
          NOW_TITLE: 'Ara',
          NOW_SUB: '{{count}} conductors connectats. S’actualitza cada 30 segons.',
          NOW_LIVE: 'En directe',
          NOW_STALE: 'Sense connexió: dades de fa una estona',
          SEE_DRIVERS: 'Veure conductors',
          ATTENTION_EMPTY: 'Tot en ordre: res pendent.',
          ATTENTION_document_expired: 'Document caducat',
          ATTENTION_document_rejected: 'Document rebutjat',
          ATTENTION_driver_without_vehicle: 'Conductor sense cotxe',
          ATTENTION_driver_request: 'Sol·licitud per unir-se',
          ATTENTION_GO_document_expired: 'Renovar',
          ATTENTION_GO_document_rejected: 'Tornar a pujar',
          ATTENTION_GO_driver_without_vehicle: 'Assignar',
          ATTENTION_GO_driver_request: 'Revisar',
          ATTENTION_MORE: 'I {{count}} més.',
          EXPIRED_ON: 'va caducar el {{date}}',
          REQUESTED_ON: 'demanat el {{date}}',
          WEEK_TITLE: 'Aquesta setmana',
          WEEK_SUB: 'Del {{from}} al {{to}} · {{trips}} viatges',
          WEEK_GO: 'Veure liquidació',
          WEEK_FARE: 'Ingressos',
          WEEK_SHARE: 'Repartiment als conductors',
          WEEK_NET: 'Net de la flota',
          WEEK_PAYOUT: 'Es liquida el {{date}}',
          AVERAGE: 'Mitjana',
          CHART_INSIGHT: '{{total}} viatges, {{average}} al dia de mitjana. El millor dia va ser el {{day}}, amb {{trips}}.',
          TOP_TITLE: 'Conductors amb més viatges',
          TOP_Q: 'Els 4 que més han treballat els últims {{days}} dies.',
          TOP_HOURS: '{{hours}} h connectat',
          START_VEHICLE: 'Afegeix un vehicle',
          START_VEHICLE_HINT: 'La matrícula, la llicència i els documents del cotxe.',
          START_CODE: 'Comparteix el codi amb els teus conductors',
          START_CODE_HINT: 'L’introdueixen a l’app WAIIS Driver i et arriba la seva sol·licitud.',
          START_SHIFTS: 'Assigna els torns',
          START_SHIFTS_HINT: 'Qui condueix cada cotxe al matí, a la tarda i a la nit.',
          START_SHIFTS_LOCKED: 'Primer necessites un cotxe i un conductor acceptat.',
          FLEET_TITLE: 'La teva flota',
          FLEET_SUB: 'Com va tot mentre WAIIS revisa l’alta.',
          TO_ACCEPT: 'Per acceptar',
          SETTLEMENTS_ON_APPROVAL: 'S’activen quan WAIIS aprovi la flota.',
        },
        DOCUMENTS: {
          KPIS_ARIA: 'Resum de documents',
          KPI_STOPPED: 'Caducats o rebutjats',
          KPI_EXPIRING: 'Caduquen en 45 dies',
          VEHICLES_SUB: 'Primer el més urgent. Prem un document per veure’l o pujar-ne un de nou.',
          FISCAL: 'Dades fiscals',
          VERIFIED: 'Verificades',
          VALID: 'Vàlid',
          APPROVED_ON: 'Aprovat el {{date}}',
          CELL_BAD: 'Caducat',
          CELL_REJ: 'Rebutjat',
          CELL_WARN: 'Caduca aviat',
          CELL_REV: 'En revisió',
          CELL_NONE: 'Falta',
          CELL_OK: 'Al dia',
          UPLOAD_SHORT: 'Pujar',
          UPCOMING_TITLE: 'Properes caducitats',
          UPCOMING_SUB: 'Propers 4 mesos',
          UPCOMING_EMPTY: 'No caduca res en els propers 4 mesos.',
          EXPIRED_ON: 'Va caducar el {{date}}',
          EXPIRES_ON: 'Caduca el {{date}}',
          CAR_STOPPED: ', cotxe aturat',
          TODAY: 'avui',
          DAYS_AGO: 'fa {{count}} dies',
          DAYS_AGO_ONE: 'fa 1 dia',
          IN_DAYS: 'd’aquí a {{count}} dies',
          IN_DAYS_ONE: 'd’aquí a 1 dia',
          REVIEW_SUB: 'Els revisem en menys de 24 h.',
          REVIEW_EMPTY: 'Encara no s’ha enviat res.',
          DRIVER_DOCS_NOTE: 'Els documents dels conductors els puja cadascú des de l’app. Els veus a la seva fitxa.',
          NOTE_BAD: 'Caducat. El cotxe no pot sortir fins que pugis el nou.',
          NOTE_REJ: 'Rebutjat. Revisa el motiu i torna’l a pujar.',
          NOTE_WARN: 'Caduca aviat. Puja’l renovat i el revisem en 24 h.',
          NOTE_REV: 'En revisió. Normalment trigam menys de 24 h.',
          NOTE_NONE: 'Falta aquest document.',
          NOTE_OK: 'Al dia.',
          NOTE_FISCAL_OK: 'Verificades per WAIIS.',
          LEGAL_NAME: 'Raó social',
          TAX_ID: 'CIF o NIF',
          ADDRESS: 'Adreça fiscal',
          FISCAL_EMPTY: 'Encara no has omplert les dades fiscals.',
          FISCAL_HINT: 'Es canvien a Configuració; si canvien, WAIIS les torna a revisar.',
          GO_SETTINGS: 'Anar a Configuració',
          CURRENT_FILE: 'Fitxer actual',
          UPLOAD_FIRST: 'Pujar el document',
          UPLOAD_NEW: 'Pujar-ne un de nou',
          SAMPLE: 'El que revisem',
          CHECKS: {
            bank_ownership_certificate: 'IBAN i titular visibles|A nom de l’empresa|Es veuen les 4 cantonades',
            route_sheet_authorization: 'Es veuen el teu NIF i el de WAIIS|Tipus Intermediari / Plataforma',
          },
        },
        SETTLEMENTS: {
          INFO_TEXT: 'Els pagaments als conductors des de la wallet arribaran més endavant. Aquí veus l’extracte, el que li toca a cada conductor i els moviments.',
          STATEMENT: 'Extracte',
          STATEMENT_EXPORT: 'Extracte',
          STATEMENT_ERROR: 'No s’ha pogut carregar l’extracte.',
          PREVIOUS: 'Període anterior',
          NEXT: 'Període següent',
          PERIOD_ARIA: 'Període',
          PERIOD_WEEK: 'Setmana',
          PERIOD_MONTH: 'Mes',
          OPENING: 'Saldo inicial',
          TRIPS: 'Viatges',
          TRIPS_COUNT: '{{count}} viatges',
          TOLLS: 'Peatges',
          TOLLS_SUB: 'Reemborsats pel passatger',
          DRIVER_SHARE: 'Repartiment als conductors',
          CANCELLATIONS: 'Cancel·lacions cobrades',
          PAYOUTS: 'Liquidat al teu compte',
          CLOSING: 'Saldo final',
          AVAILABLE_ON: 'Disponible el {{date}}',
          FEE_INFO: 'Quota dels passatgers: {{amount}}. La paguen ells a sobre de la tarifa; no es descompta del teu saldo.',
          BY_DRIVER: 'Repartiment per conductor',
          BY_DRIVER_SUB: '{{amount}} en total. Els assalariats no hi surten: no tenen repartiment.',
          BY_DRIVER_EMPTY: 'Ningú amb repartiment en aquest període.',
          COL_GENERATED: 'Generat',
          COL_SHARE: 'Repartiment',
          COL_PAYABLE: 'A pagar',
          COL_STATUS: 'Estat',
          STATUS_PAID: 'Pagat',
          STATUS_PENDING: 'Pendent',
          PAID_AT: 'Pagat el {{date}}',
          WALLET: 'Wallet de la flota',
          HELD: 'Retingut',
          HELD_UNTIL: 'Retingut fins al {{date}}',
          SHARE_SUB: 'El que es queda el conductor. Pots canviar-ho a la fitxa de cadascú.',
          SHARE_HINT: 'Els assalariats no tenen repartiment. No canvia el dels conductors ja acceptats.',
          SAVED: 'Desat',
          WAITING_TITLE: 'S’activen quan s’aprovi la flota',
          WAITING_TEXT: 'Cada dilluns veuràs el saldo de la setmana i el repartiment per conductor.',
          WAITING_IBAN: 'Cobres a {{iban}}.',
        },
        PERFORMANCE: {
          NO_DATA_TITLE: 'Encara no hi ha dades',
          NO_DATA_TEXT: 'Apareixeran quan els teus conductors comencin a fer viatges.',
          KPIS_ARIA: 'Rendiment de les últimes 4 setmanes',
          KPI_RATING: 'Valoració mitjana',
          KPI_ACCEPTANCE: 'Acceptació',
          KPI_CANCELLATION: 'Cancel·lació del conductor',
          KPI_FARE_HOUR: '€ per hora connectat',
          DRIVERS_SUB: 'Últimes 4 setmanes.',
          SORT_ARIA: 'Ordenar per',
          SORT_FARE_PER_HOUR: '€ / hora',
          SORT_RATING: 'Valoració',
          SORT_ACCEPTANCE_RATE: 'Acceptació',
          SORT_TRIPS: 'Viatges',
          COL_FARE_HOUR: '€ / h',
          COL_CANCELLATION: 'Cancel.',
          DEMAND_TITLE: 'Hores amb més demanda',
          DEMAND_SUB: 'Viatges per hora, mitjana de {{weeks}} setmanes.',
          DEMAND_TIP: '{{hour}} h: {{trips}} viatges',
          PEAK: 'De {{from}} a {{to}} h és quan més se’n demanen: {{trips}} viatges per hora.',
          PEAK_PARKED: 'De {{from}} a {{to}} h tens {{parked}} cotxes aturats i {{trips}} viatges per hora. És on més es nota un torn extra.',
        },
        REPORTS: {
          MONTHS_ARIA: 'Mes',
          CLOSED_ON: 'Tancat el {{date}}',
          OPEN: 'Mes en curs',
          PAID_DRIVERS: 'Pagat als conductors',
          DRIVERS_COUNT: '{{count}} conductors',
          NET: 'Net de la flota',
          FEE: 'Quota dels passatgers',
          FEE_SUB: 'Només com a dada',
          DOWNLOAD_TITLE: 'Descarregar',
          DOWNLOAD_SUB: 'Del mes seleccionat.',
          REPORT_trips: 'Viatges',
          REPORT_trips_HINT: 'Conductor, vehicle, import, canal i quota de cada viatge',
          REPORT_driver_settlements: 'Liquidació per conductor',
          REPORT_driver_settlements_HINT: 'Un PDF per conductor, a punt per a la gestoria',
          REPORT_route_sheets: 'Fulls de ruta',
          REPORT_route_sheets_HINT: 'El que s’ha comunicat al Ministeri per vehicle',
          COUNT_ROWS: '{{count}} files',
          COUNT_FILES: '{{count}} fitxers',
          COUNT_VEHICLES: '{{count}} vehicles',
          FILE_trips: 'viatges',
          FILE_driver_settlements: 'liquidacions_conductors',
          FILE_route_sheets: 'fulls_de_ruta',
          PAST_TITLE: 'Mesos anteriors',
          COL_MONTH: 'Mes',
          ACCOUNTANT_TITLE: 'Gestoria',
          MONTHLY_EMAIL: 'Enviar la liquidació cada mes',
          MONTHLY_EMAIL_SUB: 'El dia 1, la del mes tancat.',
          EMAIL: 'Correu de la gestoria',
          EMAIL_PLACEHOLDER: 'gestoria@exemple.com',
          EMAIL_INVALID: 'Escriu un correu vàlid.',
          EMAIL_REQUIRED: 'Escriu el correu de la gestoria per activar l’enviament.',
          ACCOUNTANT_ACCESS: 'Accés directe al panell',
          ACCOUNTANT_ACCESS_SUB: 'Convida-la a Equip amb el rol Comptable.',
        },
        TEAM: {
          INVITE: 'Convidar',
          INVITE_TITLE: 'Convidar a l’equip',
          ROLES_TITLE: 'Rols',
          YOUR_ROLE: 'El teu rol',
          ROLE_SUB_fleet_owner: 'Tot, inclosos els diners i l’equip',
          ROLE_SUB_fleet_manager: 'L’operació del dia a dia',
          ROLE_SUB_fleet_accountant: 'Només diners i papers',
          AREA_DRIVERS_VEHICLES: 'Conductors i vehicles',
          AREA_DOCUMENTS: 'Documents',
          AREA_MONEY: 'Liquidacions i wallet',
          AREA_REPORTS: 'Informes',
          AREA_TEAM_SETTINGS: 'Equip i configuració',
          COL_LAST_SEEN: 'Últim accés',
          INVITED_ON: 'Convidat el {{date}}',
          RESEND: 'Reenviar',
          RESENT: 'Reenviada',
          RESEND_ERROR: 'No s’ha pogut reenviar la invitació',
          ROLE_ERROR: 'No s’ha pogut canviar el rol',
          ALREADY_MEMBER: '{{email}} ja és a l’equip.',
          NAME: 'Nom',
          NAME_PLACEHOLDER: 'Nom i cognoms',
          EMAIL_PLACEHOLDER: 'nom@empresa.com',
        },
        SETTINGS: {
          BANK_TITLE: 'Compte bancari',
          BANK_SUB: 'On cobres les liquidacions.',
          CHANGE_IBAN: 'Canviar l’IBAN',
          IBAN_HINT: 'Si canvies l’IBAN et demanarem un certificat de titularitat nou, i el revisem abans de fer-lo servir.',
          NEW_IBAN: 'IBAN nou',
          IBAN_INVALID: 'Escriu un IBAN espanyol: ES i 22 xifres.',
          IBAN_CERT_HINT: 'Del banc, a nom de l’empresa, amb l’IBAN nou visible.',
          SAVE_IBAN: 'Desar IBAN i certificat',
          RULES_TITLE: 'Regles',
          RULES_SUB: 'S’apliquen a tots els conductors de la flota.',
          RULE_expiryReminders: 'Avisar abans que caduqui un document',
          RULE_expiryReminders_HINT: '30 i 7 dies abans, al conductor i a tu',
          RULE_blockOnExpiry: 'Bloquejar en caducar',
          RULE_blockOnExpiry_HINT: 'El conductor no es connecta fins que renovi. El cotxe queda lliure.',
          RULE_acceptCash: 'Acceptar efectiu',
          RULE_acceptCash_HINT: 'El conductor ho declara a l’app i es descompta de la seva liquidació',
          RULE_cancellationAlert: 'Avís per cancel·lacions',
          RULE_cancellationAlert_HINT: 'Si un conductor passa del 5 % a la setmana',
        },
        ONBOARDING: {
          ENTITY_NOTE: 'Tria Empresa si factures amb una societat (SL, SA, cooperativa…), encara que siguis l’únic soci. Tria Autònom si factures a nom teu. Les dades que demanem canvien segons el cas.',
          TAX_ID_HINT: 'El que et va assignar Hisenda. El fem servir a les teves factures.',
          VTC_TAX_ID_NOTE: 'Ha de ser el mateix NIF amb què les teves autoritzacions VTC són al Registre del Ministeri. Si no coincideix, no podrem comunicar els teus fulls de ruta.',
          VTC_ROUTE_SHEETS_NOTE: 'WAIIS comunica per tu cada servei al Registre del Ministeri. Només has d’autoritzar-nos (t’ho demanem al pas d’apoderament). No emetre’ls pot suposar una multa.',
          REP_TITLE: 'Representant i flota',
          SIZE_TITLE: 'Mida de la flota',
          SIZE_VALUE: '{{vehicles}} vehicles · {{drivers}} conductors',
          SIZE_VEHICLES: 'Vehicles',
          SIZE_DRIVERS: 'Conductors',
          REP_ROLE_LABEL: 'El teu càrrec a l’empresa',
          REP_PLACEHOLDER: 'Tria el teu càrrec',
          REP_REQUIRED: 'Tria el teu càrrec a l’empresa.',
          REP_ROLE: {
            sole_admin: 'Administrador únic',
            joint_admin: 'Administrador solidari o mancomunat',
            shareholder_25: 'Soci amb més del 25 %',
            attorney: 'Apoderat',
          },
          OWNERS_LABEL: 'Socis amb més del 25 %',
          OWNER_NAME: 'Nom i cognoms',
          OWNER_ID: 'DNI / NIE',
          OWNER_ADD: 'Afegir un altre soci',
          OWNER_REMOVE: 'Treure el soci',
          OWNERS_INVALID: 'Posa el nom i un DNI o NIE vàlid de cada soci.',
          DISCLAIMER_TITLE: 'Accepto l’exempció de responsabilitat',
          DISCLAIMER_REQUIRED: 'Accepta l’exempció de responsabilitat per desar.',
          CAPTURE_LIKE_THIS: 'Captura-ho així',
          OPEN_REGISTRY: 'Obrir el Registre VTC',
          NEW_TAB: '(s’obre en una pestanya nova)',
          ROUTE_STEP_1: 'Entra al Registre VTC del Ministeri amb Cl@ve o el teu certificat digital.',
          ROUTE_STEP_2: 'A «Autoritzar comunicacions», autoritza el NIF de WAIIS:',
          ROUTE_STEP_3: 'Com a tipus, tria «Intermediari / Plataforma» i marca «Gestionar totes les meves autoritzacions».',
          ROUTE_STEP_4: 'Fes una captura on es vegin el teu NIF i l’autoritzat, i puja-la aquí.',
          COPY: 'Copiar',
          COPIED: 'Copiat',
          SEND_TITLE: 'Enviar a revisió',
          SEND_SUB: 'Ho revisem en menys de 24 h i t’avisem per correu.',
          MEANWHILE: 'Mentrestant',
          ON_APPROVAL: 'Quan s’aprovi',
          MEANWHILE_VEHICLES: 'Afegir vehicles i els seus documents',
          MEANWHILE_CODE: 'Compartir el teu codi amb els conductors',
          MEANWHILE_SHIFTS: 'Crear els torns',
          APPROVAL_DRIVERS: 'Els conductors es poden connectar',
          APPROVAL_SETTLEMENTS: 'Comencen les liquidacions',
        },
        DRIVERS: {
          TAB_AVAILABLE: 'Lliures',
          TAB_ON_TRIP: 'En viatge',
          TAB_OFFLINE: 'Desconnectats',
          TAB_PENDING: 'Sol·licituds',
          ADD: 'Afegir conductor',
          ADD_SUB: 'S’hi uneixen amb el codi de la teva flota des de l’app WAIIS Driver.',
          ADD_NOTE: 'Quan l’introdueixin, et arribarà la seva sol·licitud aquí. Acceptar-la és l’únic que has de fer.',
          COPY: 'Copiar',
          COPIED: 'Copiat',
          COPY_MESSAGE: 'Copiar missatge',
          CHANGE_CODE: 'Canviar codi',
          DONE: 'Fet',
          STEPS_TITLE: 'Com s’hi uneixen',
          STEP_1: 'Es descarreguen l’app WAIIS Driver i creen el seu compte.',
          STEP_2: 'Pugen el DNI, el carnet de conduir i el permís de conductor professional.',
          STEP_3: 'A «Unir-me a una flota» escriuen el codi {{code}}.',
          STEP_4: 'Acceptes la seva sol·licitud en aquesta pantalla i ja poden treballar a la teva flota.',
          MESSAGE_TITLE: 'Missatge per enviar-los',
          JOIN_MESSAGE: 'Hola! Per treballar amb nosaltres, descarrega’t l’app WAIIS Driver, crea el teu compte i, a «Unir-me a una flota», escriu el codi {{code}}. Tan bon punt t’acceptem ja pots començar.',
          KPIS_ARIA: 'Resum de conductors',
          KPI_ONLINE: 'Connectats ara',
          SEARCH: 'Cercar per nom, telèfon o matrícula',
          COL_STATE: 'Estat',
          COL_NEXT: 'Següent pas',
          COL_VEHICLE: 'Vehicle',
          COL_SHIFT: 'Torn',
          COL_TRIPS: 'Viatges',
          COL_RATING: 'Valoració',
          COL_WEEK: '€ setmana',
          EMPTY_all: 'Encara no tens conductors. Passa’ls el codi de la flota perquè s’hi uneixin.',
          EMPTY_available: 'Ara mateix no hi ha ningú lliure.',
          EMPTY_on_trip: 'Ara mateix no hi ha ningú en viatge.',
          EMPTY_offline: 'Tots els teus conductors estan connectats.',
          EMPTY_pending: 'No hi ha sol·licituds pendents.',
          EMPTY_with_alerts: 'Cap conductor té documents per renovar.',
          YOU: 'Tu',
          STATE_PENDING: 'Sol·licitud',
          STATE_REJECTED: 'Rebutjat',
          STATE_INACTIVE: 'Desactivat',
          STATE_READY: 'Llest',
          STATE_VERIFYING: 'Verificant',
          STATE_ON_TRIP: 'En viatge',
          STATE_AVAILABLE: 'Lliure',
          STATE_OFFLINE: 'Desconnectat',
          NEXT_ACCEPT: 'Accepta la seva sol·licitud',
          NEXT_APPROVAL: 'Esperant que WAIIS aprovi la flota',
          NEXT_VERIFY: 'WAIIS revisa els seus documents',
          DOCS_ok: 'Al dia',
          DOCS_warn: 'Caduca aviat',
          DOCS_bad: 'Caducat o rebutjat',
          DOCS_review: 'En revisió',
          DOCS_missing: 'Falten',
          PENDING_NOTE: 'Va demanar unir-se a la flota el {{date}}. Revisa les seves dades i accepta o rebutja la sol·licitud.',
          STAT_HOURS: 'Connectat',
          VEHICLE_TITLE: 'Vehicle',
          VEHICLE_SHIFT_TITLE: 'Vehicle i torn',
          NO_VEHICLE: 'Sense vehicle assignat',
          NO_SHIFT: 'Sense torn',
          EDIT_SHIFTS: 'Editar torns',
          SHARE_TITLE: 'Repartiment',
          SHARE_PERCENT: 'Percentatge',
          SHARE_SPLIT: 'Conductor {{driver}} % · Flota {{fleet}} %',
          SALARIED_NOTE: 'Cobra una nòmina: la flota es queda el que factura.',
          SHARE_RANGE: 'El percentatge ha d’estar entre 30 i 80.',
          UNLINK: 'Desvincular',
          DEACTIVATE: 'Desactivar',
          REACTIVATE: 'Reactivar',
          DEACTIVATE_TITLE: 'Desactivar {{name}}?',
          REACTIVATE_TITLE: 'Reactivar {{name}}?',
          DEACTIVATE_TEXT: 'No podrà connectar-se ni rebre viatges de la flota fins que el reactivis. Continua vinculat i conserva els seus torns.',
          REACTIVATE_TEXT: 'Podrà tornar a connectar-se i rebre viatges de la flota.',
        },
        REVIEW_BAR: {
          IN_REVIEW_TITLE: 'Flota en revisió',
          IN_REVIEW_TEXT: 'Afegeix vehicles i comparteix el teu codi amb els conductors. Es podran connectar quan aprovem la flota.',
          REJECTED_TITLE: 'Hi ha alguna cosa rebutjada',
          REJECTED_REST: 'La resta continua en revisió.',
          STEPS_ARIA: 'Passos de l’alta',
          STEP_billing_info: 'Facturació',
          STEP_bank_ownership_certificate: 'Banc',
          STEP_route_sheet_authorization: 'Fulls de ruta',
          SEE_STATUS: 'Veure l’estat',
          FIX: 'Tornar a pujar',
          START_WHILE_REVIEW: 'Ja ho pots fer: els teus conductors es podran connectar tan aviat com aprovem la flota.',
        },
        ACTIVE: 'Activa',
        INACTIVE: 'Inactiva',
        REFRESH: 'Actualitzar',
        SHOW_MORE: 'Veure’n més',
        COL_UPDATED: 'Actualitzada',
        DELETING: 'Esborrant…',
        DELETED: 'Esborrat',
        REASON_PLACEHOLDER: 'Motiu (obligatori, queda a l’auditoria)',
        REASON_REQUIRED: 'Indica el motiu.',
        ASSOCIATE_NOTE: 'Entra com a soci de l’emissora: treballa amb la seva llicència i el seu cotxe i cobra els seus viatges íntegres.',
        ACCEPT_ASSOCIATE_TITLE: 'Acceptar com a soci',
        SHARE_ASSOCIATE: 'No s’aplica (soci: cobra íntegre)',
        STANDS: {
          ADD: 'Nova parada',
          LIST_TITLE: 'Parades',
          LIST_SUB: 'En entrar a la geotanca, el taxista es posa a la cua d’aquesta parada.',
          COL_NAME: 'Nom',
          COL_QUEUE: 'A la cua',
          COL_CAPACITY: 'Capacitat',
          EMPTY: 'Encara no hi ha parades.',
          LOAD_ERROR: 'No s’han pogut carregar les parades.',
          QUEUE_TITLE: 'Cua de {{name}}',
          QUEUE_SUB: 'En directe: s’actualitza sola cada 15 segons.',
          QUEUE_EMPTY: 'No hi ha ningú a la cua.',
          QUEUE_ERROR: 'No s’ha pogut carregar la cua.',
          QUEUE_RULES: 'Regles de la cua: després dels rebuigs seguits que marca la política de repartiment, el taxista surt amb un avís; saltar una oferta per requisits no li fa perdre el lloc. Rebutjar mai no multa.',
          WAITING: 'esperant {{minutes}} min',
          REJECTIONS: 'Rebuigs seguits: {{count}}',
          REJECTIONS_TIP: 'Ofertes rebutjades seguides des que va entrar a la cua.',
          SKIPS: 'Salts per requisits: {{count}}',
          SKIPS_TIP: 'Ofertes que no podia fer (PMR, mascota…): no compten com a rebuig.',
          REMOVE: 'Treure de la cua',
          REMOVING: 'Traient…',
          REMOVED: 'Fora de la cua',
          REMOVE_TITLE: 'Treure {{name}} de la cua',
          REMOVE_TEXT: 'Sortirà de la cua de {{stand}} i rebrà un avís.',
          REMOVE_PLACEHOLDER: 'Motiu (obligatori, el veurà el taxista)',
          REMOVE_ERROR: 'No s’ha pogut treure de la cua',
          DRAWER_SUB: 'Dibuixa la geotanca i col·loca el punt de la parada.',
          DATA_TITLE: 'Dades de la parada',
          ADDRESS: 'Adreça',
          CAPACITY_HINT: 'Orientativa: no fa fora ningú de la cua.',
          CAPACITY_INVALID: 'Entre 1 i 50.',
          ACTIVE_LABEL: 'Parada activa',
          GEOFENCE_TITLE: 'Geotanca i punt',
          GEOFENCE_HINT: 'La zona en què el taxista entra a la cua. El punt és el que es veu al mapa i a l’app.',
          POINT_INVALID: 'El punt de la parada ha d’estar dins de la seva geotanca.',
          CREATE: 'Crear parada',
          DELETE: 'Esborrar parada',
          DELETE_TITLE: 'Esborrar la parada {{name}}',
          DELETE_TEXT: 'Es buida la seva cua i els taxistes que hi eren reben un avís.',
          DELETE_ERROR: 'No s’ha pogut esborrar la parada',
          DELETED_QUEUE: 'Parada esborrada. Han sortit de la cua {{count}} taxistes.',
        },
        ZONES: {
          ADD: 'Nova zona',
          TITLE: 'Zones',
          SUB: 'Les fan servir el repartiment «Per zona» i els informes. Poden solapar-se: guanya la més petita.',
          COL_NAME: 'Nom',
          COL_POINTS: 'Punts',
          EMPTY: 'Encara no hi ha zones.',
          LOAD_ERROR: 'No s’han pogut carregar les zones.',
          DRAWER_SUB: 'Dibuixa la zona al mapa. De fons, les altres.',
          ACTIVE_LABEL: 'Zona activa',
          SHAPE_TITLE: 'Forma de la zona',
          CREATE: 'Crear zona',
          DELETE: 'Esborrar zona',
          DELETE_TITLE: 'Esborrar la zona {{name}}',
          DELETE_TEXT: 'Deixa de fer-se servir en el repartiment. Els viatges passats no canvien.',
          DELETE_ERROR: 'No s’ha pogut esborrar la zona',
        },
        POLICY: {
          LOAD_ERROR: 'No s’ha pogut carregar la política de repartiment.',
          NOTE_TITLE: 'Rebutjar mai no multa',
          NOTE_TEXT: 'Aquests valors només ordenen a qui s’ofereix cada servei. Cada canvi queda a l’historial amb el seu autor.',
          STRATEGY_TITLE: 'Com es reparteixen els serveis',
          STRATEGY_SUB: 'A qui s’ofereix primer cada servei entre els socis disponibles.',
          STRATEGY_HINT_proximity: 'Al soci lliure més proper a l’origen.',
          STRATEGY_HINT_stand_order: 'Al primer de la cua de la parada més propera; si no hi ha cua, al més proper.',
          STRATEGY_HINT_zone: 'Primer als socis de la zona de l’origen, per ordre d’arribada a la zona.',
          INTRA_FLEET: 'Els socis de l’emissora reben les ofertes abans que altres conductors WAIIS',
          QUEUE_TITLE: 'Ofertes i cua',
          QUEUE_SUB: 'Quant dura cada oferta i quan surt algú de la cua d’una parada.',
          TIMEOUT_HINT: 'Temps per acceptar una oferta abans de passar al següent (10–60 s).',
          TIMEOUT_INVALID: 'Entre 10 i 60 segons.',
          REJECTIONS_HINT: 'Rebuigs seguits després dels quals el taxista surt de la cua amb un avís (1–5).',
          REJECTIONS_INVALID: 'Entre 1 i 5.',
          LAST_CHANGE: 'Últim canvi: {{name}}, {{date}}.',
          OUTDATED_TITLE: 'La política ha canviat',
          HISTORY_TITLE: 'Historial de canvis',
          HISTORY_SUB: 'Qui ha canviat què i quan.',
          HISTORY_EMPTY: 'Encara no hi ha canvis.',
          FIELD: {
            strategy: 'Repartiment',
            intra_fleet_priority: 'Prioritat als socis',
            offer_timeout_seconds: 'Temps de cada oferta',
            stand_max_consecutive_rejections: 'Rebuigs seguits per sortir de la cua',
            skip_by_requirements_keeps_position: 'Saltar una oferta per requisits conserva el lloc a la cua',
          },
        },
        FEES: {
          ADD_RULE: 'Nova regla',
          ADD_RULE_SUB: 'Una quota per a una ciutat, un mode o un tipus de servei concrets.',
          EDIT_RULE: 'Canviar la quota',
          NOTE_TITLE: 'Només paga quota la demanda que genera WAIIS',
          NOTE_TEXT:
            'S’afegeix al preu del viatge: el taxista o la flota cobren la tarifa íntegra. Els clients propis de l’emissora (el seu telèfon, la seva web, la parada i el carrer) van sempre a 0 €. La quota es congela en crear el viatge.',
          LOAD_ERROR: 'No s’ha pogut carregar la quota al passatger.',
          MATRIX_TITLE: 'Imports',
          MATRIX_SUB: 'Les regles generals valen per a totes les ciutats; les altres les afinen.',
          COL_SERVICE: 'Tipus de servei',
          COL_AMOUNT: 'Quota',
          COL_CHANNEL: 'Canal',
          COL_STATE: 'Quota',
          COL_REASON: 'Motiu',
          GENERAL: 'General',
          PRIORITY: 'Per a un viatge guanya la regla més concreta: ciutat i mode, després ciutat, després mode i finalment la general.',
          AMOUNT_HINT: 'De 0 a 10 €. Amb 0 € no es cobra quota.',
          AMOUNT_INVALID: 'Posa un import entre 0 i 10 €.',
          DUPLICATE: 'Ja hi ha una regla per a aquesta ciutat, mode i tipus de servei: canvia’n l’import.',
          REQUIRED_RULE: 'Les regles generals no s’esborren: posa-les a 0 €.',
          SAVE_ERROR: 'No s’ha pogut desar la quota',
          DELETE: 'Esborrar regla',
          DELETE_TITLE: 'Esborrar la regla',
          DELETE_TEXT: '{{rule}}. A partir d’ara s’aplica la regla més general que quedi.',
          DELETE_ERROR: 'No s’ha pogut esborrar la regla',
          REGIONS_TITLE: 'Interruptor per ciutat',
          REGIONS_SUB: 'Amb la quota apagada, els passatgers d’aquesta ciutat paguen 0 € encara que hi hagi regles. Activa a {{enabled}} de {{total}}.',
          ON: 'Activa',
          OFF: 'Apagada',
          ENABLE: 'Activar',
          DISABLE: 'Apagar',
          ENABLE_TITLE: 'Activar la quota a {{region}}',
          ENABLE_TEXT: 'Els viatges que es creïn a partir d’ara amb l’app WAIIS pagaran la quota de la matriu.',
          DISABLE_TITLE: 'Apagar la quota a {{region}}',
          DISABLE_TEXT: 'Els viatges que es creïn a partir d’ara aniran a 0 €. Els ja creats no canvien.',
          SIM_TITLE: 'Simulador',
          SIM_SUB: 'El que pagaria un passatger amb la matriu actual.',
          FARE: 'Preu del viatge',
          SIMULATE: 'Calcular',
          SIM_INVALID: 'Tria una ciutat i posa un preu.',
          PASSENGER_TOTAL: 'Paga el passatger',
          REASON: {
            rule: 'Regla aplicada: {{rule}}.',
            channel_exempt: 'Client propi de l’emissora: sense quota.',
            region_disabled: 'La quota està apagada en aquesta ciutat.',
            no_rule: 'No hi ha regla per a aquest tipus de servei: sense quota.',
          },
          HISTORY_TITLE: 'Auditoria',
          HISTORY_SUB: 'Tots els canvis de la matriu i dels interruptors.',
          ACTION: {
            rule_created: 'Nova regla «{{target}}»: {{to}}',
            rule_updated: 'Regla «{{target}}»: {{from}} → {{to}}',
            rule_deleted: 'Regla esborrada «{{target}}» (era {{from}})',
            region_toggled: '{{target}}: quota {{from}} → {{to}}',
          },
        },
        CHALLENGES: {
          ADD: 'Nou repte',
          TABS_ARIA: 'Estat dels reptes',
          TAB_ALL: 'Tots',
          PANEL_TITLE: 'Reptes',
          PANEL_SUB: 'La bonificació s’abona sola a la cartera del conductor quan compleix el repte.',
          SEARCH: 'Cercar per títol',
          COL_CHALLENGE: 'Repte',
          COL_SCOPE: 'Per a',
          COL_GOALS: 'Objectius',
          COL_BONUS: 'Bonificació',
          COL_COMPLETED: 'Complert',
          EMPTY: 'No hi ha reptes amb aquests filtres.',
          LOAD_ERROR: 'No s’han pogut carregar els reptes.',
          LOAD_ONE_ERROR: 'No s’ha pogut carregar el repte.',
          SHOWING: 'Mostrant {{shown}} de {{total}} reptes',
          PER_PAGE: '{{count}} per pàgina',
          PER_PAGE_ARIA: 'Reptes per pàgina',
          GOAL_TRIPS: '{{value}} viatges',
          GOAL_HOURS: '{{value}} h connectat',
          GOAL_FARE: '{{value}} facturats',
          GOAL_RATING: 'valoració ≥ {{value}}',
          NEW_TITLE: 'Nou repte',
          DETAIL_TITLE: 'Repte',
          BACK: 'Tornar a reptes',
          SECTION_WHAT: 'El repte',
          SECTION_WHO: 'Per a qui i quan',
          SECTION_GOALS: 'Objectius',
          SECTION_BONUS: 'Bonificació',
          TITLE: 'Títol',
          DESCRIPTION: 'Descripció',
          DESCRIPTION_HINT: 'El que veurà el conductor a l’app.',
          STARTS: 'Comença',
          ENDS: 'Acaba',
          DATES_INVALID: 'Posa l’inici i el final, i que el final no sigui abans de l’inici.',
          GOALS_HINT: 'Omple els que comptin: cal complir-los tots.',
          MIN_TRIPS: 'Viatges',
          MIN_HOURS: 'Hores connectat',
          MIN_FARE: 'Facturació (€)',
          MIN_RATING: 'Valoració mínima',
          GOALS_INVALID: 'Posa almenys un objectiu (la valoració, d’1 a 5).',
          BONUS_HINT: 'D’1 a 500 €. S’abona a la cartera (línia BONUS).',
          BONUS_INVALID: 'Posa una bonificació entre 1 i 500 €.',
          CREATE: 'Crear repte',
          SAVED_TITLE: 'Repte desat',
          SAVE_ERROR: 'No s’ha pogut desar el repte.',
          LOCKED: 'Aquest repte ja ha començat: no es pot canviar.',
          PUBLISH: 'Publicar',
          PUBLISH_TITLE: 'Publicar «{{title}}»',
          PUBLISH_TEXT: 'S’avisarà els conductors d’aquesta ciutat i mode. Fins que comenci, encara es pot editar.',
          CANCEL: 'Cancel·lar el repte',
          CANCEL_TITLE: 'Cancel·lar «{{title}}»',
          CANCEL_TEXT: 'Deixa de comptar per a tothom. Les bonificacions ja pagades no es retiren.',
          DELETE: 'Esborrar',
          DELETE_TITLE: 'Esborrar «{{title}}»',
          DELETE_TEXT: 'És un esborrany: ningú no l’ha vist encara.',
          ACTION_ERROR: 'No s’ha pogut completar l’acció',
          PARTICIPANTS: 'Participants',
          PARTICIPANTS_SUB: 'Progrés de cada conductor. En verd, el que ja ha complert.',
          PARTICIPANTS_EMPTY: 'Encara no hi participa ningú.',
          PAID: 'Bonificacions pagades',
          PARTICIPANT_in_progress: 'En curs',
          PARTICIPANT_completed: 'Complert, bonificació pendent',
          PARTICIPANT_paid: 'Bonificació pagada',
        },
      },
    },
    SIDEBAR: {
      FLEET_PERFORMANCE: 'Rendiment',
      FLEET_DRIVERS_COUNT: 'Sol·licituds per acceptar: {{count}}',
      FLEET_DOCUMENTS_COUNT: 'Documents que necessiten atenció: {{count}}',
      FLEET_DISPATCH_SECTION: 'Emissora',
      FLEET_STANDS: 'Parades',
      FLEET_ZONES: 'Zones',
      FLEET_DISPATCH_POLICY: 'Política de repartiment',
      FLEET_DATA_SECTION: 'Dades',
      PASSENGER_FEES: 'Quota al passatger',
      DRIVER_CHALLENGES: 'Reptes',
    },
    PAGE_HEADER: {
      FLEET_PERFORMANCE: 'Com treballa cada conductor: viatges, hores, facturació, acceptació i valoració.',
      FLEET_STANDS: 'Les parades de l’emissora amb la seva geotanca i la seva cua en directe.',
      FLEET_ZONES: 'Les zones amb nom de l’emissora, per al repartiment i els informes.',
      FLEET_DISPATCH_POLICY: 'Com s’ofereixen els serveis entre els socis i les regles de la cua.',
      PASSENGER_FEES: 'Quant paga el passatger a sobre del preu segons la ciutat, el mode i el tipus de servei.',
      DRIVER_CHALLENGES: 'Reptes amb bonificació en € per a conductors de taxi i VTC.',
    },
  },
};
